"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleValidatePhone = exports.handleValidateEmailMask = exports.handleValidateEmail = exports.handleUpdateUserWithSocialUserData = exports.handleUpdateUserPhone = exports.handleUpdateUserAttribute = exports.handleUpdateUser = exports.handleSubmitAccountForm = exports.handleSocialLoginSucceeded = exports.handleSendAccessCode = exports.handleSaveRedirectUrl = exports.handleSaveQuery = exports.handleSaveLoginProvider = exports.handleRequestFailure = exports.handleRefreshProfile = exports.handleLoginSucceeded = exports.handleLoginSocialPhoneMatched = exports.handleLoginSocialCredentialMatched = exports.handleAccountOwnershipSendCodeConfirmation = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reduxPack = require("redux-pack");
var _constants = require("./constants");
var _incognia = _interopRequireDefault(require("../utils/incognia"));
var _getPhoneNumberInfo = require("../utils/getPhoneNumberInfo");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var handleLoginSucceeded = function handleLoginSucceeded(draft, action) {
  draft.user = _objectSpread(_objectSpread({}, draft.user), {}, {
    isLoggedIn: true,
    id: action.loginData.user_id,
    agentId: action.loginData.agent_id,
    name: action.loginData.user_name,
    email: action.loginData.user_email,
    jwt: _objectSpread(_objectSpread({}, draft.user.jwt), {}, {
      app: action.loginData.json_web_token,
      firebase: action.loginData.firebase_json_web_token
    })
  });
  if (draft.user.riskAssessmentToken) {
    var data = action.loginData;
    if (data && data.person_uuid && data.user_phone) {
      _incognia.default.setAccountId(data.person_uuid).then(_incognia.default.sendAuthorizedLoginEvent(data.person_uuid, data.user_phone)).catch(function () {
        return console.log("Failed setting risk assessment context");
      });
    }
  }
  return draft;
};
exports.handleLoginSucceeded = handleLoginSucceeded;
var handleSocialLoginSucceeded = function handleSocialLoginSucceeded(draft, action) {
  draft.user = _objectSpread(_objectSpread({}, draft.user), {}, {
    isLoggedIn: true,
    jwt: _objectSpread(_objectSpread({}, draft.user.jwt), {}, {
      app: action.loginData.authToken,
      firebase: action.loginData.firebaseAuthToken
    })
  });
  return draft;
};
exports.handleSocialLoginSucceeded = handleSocialLoginSucceeded;
var handleRequestFailure = function handleRequestFailure(_ref) {
  var payload = _ref.payload;
  return function (newDraft) {
    var details = payload.details;
    var isUserNotFoundError;
    var type = _constants.errors.unknownError;
    if (details) {
      type = details.error;
      isUserNotFoundError = details.error === _constants.errors.userNotFound;
    }
    if (newDraft.user && newDraft.user.riskAssessmentToken && newDraft.user.phone) {
      var _newDraft$user$phone, _newDraft$user$phone2, _newDraft$user$phone3;
      var countryCode = ((_newDraft$user$phone = newDraft.user.phone) === null || _newDraft$user$phone === void 0 ? void 0 : _newDraft$user$phone.countryCode) || "+55";
      var areaCode = (_newDraft$user$phone2 = newDraft.user.phone) === null || _newDraft$user$phone2 === void 0 ? void 0 : _newDraft$user$phone2.areaCode;
      var phoneNumber = (_newDraft$user$phone3 = newDraft.user.phone) === null || _newDraft$user$phone3 === void 0 ? void 0 : _newDraft$user$phone3.phoneNumber;
      var userPhone = "".concat(countryCode).concat(areaCode).concat(phoneNumber);
      _incognia.default.sendDeniedLoginEvent(userPhone).catch(function () {
        return console.log("Failed sending risk assessment event");
      });
    }
    if (isUserNotFoundError) {
      return newDraft;
    }
    newDraft.response = _objectSpread(_objectSpread({}, newDraft.response), {}, {
      status: _constants.ERROR,
      type: type
    });
    return newDraft;
  };
};
exports.handleRequestFailure = handleRequestFailure;
var handleSendAccessCode = function handleSendAccessCode(draft, action) {
  return (0, _reduxPack.handle)(draft, action, {
    start: function start(newDraft) {
      newDraft.isRequestOngoing = true;
      newDraft.request.sendAccessCodeStatus = _constants.REQUEST_STATUS.LOADING;
      newDraft.response = {};
      return newDraft;
    },
    success: function success(newDraft) {
      newDraft.user = _objectSpread(_objectSpread({}, newDraft.user), {}, {
        sessionId: action.payload.sessionId
      });
      newDraft.request.sendAccessCodeStatus = _constants.REQUEST_STATUS.SUCCESS;
      return newDraft;
    },
    failure: function failure(newDraft) {
      newDraft.request.sendAccessCodeStatus = _constants.REQUEST_STATUS.FAILURE;
      return handleRequestFailure(action)(newDraft);
    },
    finish: function finish(newDraft) {
      newDraft.isRequestOngoing = false;
      return newDraft;
    }
  });
};
exports.handleSendAccessCode = handleSendAccessCode;
var handleAccountOwnershipSendCodeConfirmation = function handleAccountOwnershipSendCodeConfirmation(draft, action) {
  return (0, _reduxPack.handle)(draft, action, {
    start: function start(newDraft) {
      newDraft.isRequestOngoing = true;
      newDraft.request.sendAccessCodeStatus = _constants.REQUEST_STATUS.LOADING;
      newDraft.response = {};
      return newDraft;
    },
    success: function success(newDraft) {
      newDraft.response = {
        status: _constants.SUCCESS,
        type: _constants.success.resendAccessCode
      };
      newDraft.request.sendAccessCodeStatus = _constants.REQUEST_STATUS.SUCCESS;
      return newDraft;
    },
    failure: function failure(newDraft) {
      newDraft.request.sendAccessCodeStatus = _constants.REQUEST_STATUS.FAILURE;
      return handleRequestFailure(action)(newDraft);
    },
    finish: function finish(newDraft) {
      newDraft.isRequestOngoing = false;
      return newDraft;
    }
  });
};
exports.handleAccountOwnershipSendCodeConfirmation = handleAccountOwnershipSendCodeConfirmation;
var handleValidatePhone = function handleValidatePhone(draft, action) {
  return (0, _reduxPack.handle)(draft, action, {
    start: function start(newDraft) {
      newDraft.isRequestOngoing = true;
      newDraft.request.pinCodeValidationStatus = _constants.REQUEST_STATUS.LOADING;
      newDraft.response = {};
      return newDraft;
    },
    success: function success(newDraft) {
      newDraft.user = _objectSpread(_objectSpread({}, newDraft.user), {}, {
        maskedEmail: action.payload.emailMask
      });
      newDraft.request.pinCodeValidationStatus = _constants.REQUEST_STATUS.SUCCESS;
      return newDraft;
    },
    failure: function failure(newDraft) {
      newDraft.request.pinCodeValidationStatus = _constants.REQUEST_STATUS.FAILURE;
      return handleRequestFailure(action)(newDraft);
    },
    finish: function finish(newDraft) {
      newDraft.isRequestOngoing = false;
      return newDraft;
    }
  });
};
exports.handleValidatePhone = handleValidatePhone;
var handleValidateEmail = function handleValidateEmail(draft, action) {
  return (0, _reduxPack.handle)(draft, action, {
    start: function start(newDraft) {
      newDraft.isRequestOngoing = true;
      newDraft.request.pinCodeValidationStatus = _constants.REQUEST_STATUS.LOADING;
      newDraft.response = {};
      return newDraft;
    },
    success: function success(newDraft) {
      newDraft.request.pinCodeValidationStatus = _constants.REQUEST_STATUS.SUCCESS;
      return newDraft;
    },
    failure: function failure(newDraft) {
      newDraft.request.pinCodeValidationStatus = _constants.REQUEST_STATUS.FAILURE;
      return handleRequestFailure(action)(newDraft);
    },
    finish: function finish(newDraft) {
      newDraft.isRequestOngoing = false;
      return newDraft;
    }
  });
};
exports.handleValidateEmail = handleValidateEmail;
var handleValidateEmailMask = function handleValidateEmailMask(draft, action) {
  return (0, _reduxPack.handle)(draft, action, {
    start: function start(newDraft) {
      newDraft.isRequestOngoing = true;
      newDraft.response = {};
      return newDraft;
    },
    failure: handleRequestFailure({
      payload: {
        details: {
          error: _constants.errors.invalidEmailMask
        }
      }
    }),
    finish: function finish(newDraft) {
      newDraft.isRequestOngoing = false;
      return newDraft;
    }
  });
};
exports.handleValidateEmailMask = handleValidateEmailMask;
var handleSubmitAccountForm = function handleSubmitAccountForm(draft, action) {
  return (0, _reduxPack.handle)(draft, action, {
    start: function start(newDraft) {
      newDraft.isRequestOngoing = true;
      newDraft.request.submitAccountStatus = _constants.REQUEST_STATUS.LOADING;
      newDraft.response = {};
      return newDraft;
    },
    success: function success(newDraft) {
      newDraft.accountForm = _objectSpread(_objectSpread({}, newDraft.accountForm), action.meta.payload);
      newDraft.request.submitAccountStatus = _constants.REQUEST_STATUS.SUCCESS;
      return newDraft;
    },
    failure: function failure(newDraft) {
      newDraft.request.submitAccountStatus = _constants.REQUEST_STATUS.FAILURE;
      return handleRequestFailure(action)(newDraft);
    },
    finish: function finish(newDraft) {
      newDraft.isRequestOngoing = false;
      return newDraft;
    }
  });
};
exports.handleSubmitAccountForm = handleSubmitAccountForm;
var handleUpdateUser = function handleUpdateUser(draft, action) {
  draft.user = action.value;
  return draft;
};
exports.handleUpdateUser = handleUpdateUser;
var handleUpdateUserAttribute = function handleUpdateUserAttribute(draft, action) {
  draft.user[action.attr] = action.value;
  return draft;
};
exports.handleUpdateUserAttribute = handleUpdateUserAttribute;
var handleLoginSocialCredentialMatched = function handleLoginSocialCredentialMatched(draft, action) {
  var data = action.data.payload;
  draft.user = _objectSpread(_objectSpread({}, draft.user), {}, {
    sessionId: data.sessionId,
    maskedEmail: data.email,
    maskedPhone: data.phone,
    phone: _objectSpread(_objectSpread({}, draft.user.phone), {}, {
      countryCode: "+".concat(data.country)
    })
  });
  return draft;
};
exports.handleLoginSocialCredentialMatched = handleLoginSocialCredentialMatched;
var handleLoginSocialPhoneMatched = function handleLoginSocialPhoneMatched(draft, action) {
  var data = action.data.payload;
  draft.user.maskedEmail = data.maskedEmail;
  return draft;
};
exports.handleLoginSocialPhoneMatched = handleLoginSocialPhoneMatched;
var handleUpdateUserPhone = function handleUpdateUserPhone(draft, action) {
  var value = action.value;
  if (action.key === "countryCode" && !value.startsWith("+")) {
    value = "+".concat(value);
  }
  draft.user = _objectSpread(_objectSpread({}, draft.user), {}, {
    phone: _objectSpread(_objectSpread({}, draft.user.phone), {}, (0, _defineProperty2.default)({}, action.key, value))
  });
  return draft;
};
exports.handleUpdateUserPhone = handleUpdateUserPhone;
var handleUpdateUserWithSocialUserData = function handleUpdateUserWithSocialUserData(draft, action) {
  var userData = action.userData;
  draft.user.name = userData === null || userData === void 0 ? void 0 : userData.name;
  draft.user.email = userData === null || userData === void 0 ? void 0 : userData.email;
  draft.user.enableEmailUpdate = false;
  var identities = userData === null || userData === void 0 ? void 0 : userData.identities;
  draft.user.loginProvider = identities && identities[0].providerName;
  draft.user.identities = identities.map(function (identity) {
    return {
      id: identity.userId,
      provider: _constants.SOCIAL_PROVIDERS[identity.providerName.toUpperCase()]
    };
  });
  draft.user.identities.push({
    id: userData === null || userData === void 0 ? void 0 : userData.username,
    provider: _constants.COGNITO
  });
  draft.user.jwt.cognito = userData === null || userData === void 0 ? void 0 : userData.accessToken;
  return draft;
};
exports.handleUpdateUserWithSocialUserData = handleUpdateUserWithSocialUserData;
var handleRefreshProfile = function handleRefreshProfile(draft, action) {
  return (0, _reduxPack.handle)(draft, action, {
    start: function start(newDraft) {
      newDraft.isRequestOngoing = true;
      return newDraft;
    },
    success: function success(newDraft) {
      var _newDraft$user;
      var payload = action.payload;
      newDraft.user = _objectSpread(_objectSpread({}, newDraft.user), {}, {
        isLoggedIn: true,
        id: payload.id,
        hashId: payload.hashId,
        agentId: payload.agentId,
        name: payload.name,
        email: payload.email,
        jwt: _objectSpread(_objectSpread({}, newDraft.user.jwt), {}, {
          app: payload.jwt,
          firebase: payload.firebase_jwt
        }),
        acceptWhatsapp: payload.acceptWhatsapp,
        hasDocument: payload.hasDocument,
        isPartner: payload.isPartner,
        phone: _objectSpread(_objectSpread({}, newDraft === null || newDraft === void 0 ? void 0 : (_newDraft$user = newDraft.user) === null || _newDraft$user === void 0 ? void 0 : _newDraft$user.phone), (0, _getPhoneNumberInfo.getPhoneNumberInfo)(payload.phoneNumber))
      });
      if (payload.businessContext) {
        newDraft.user.businessContext = payload.businessContext;
      }
      return newDraft;
    },
    finish: function finish(newDraft) {
      newDraft.isRequestOngoing = false;
      return newDraft;
    }
  });
};
exports.handleRefreshProfile = handleRefreshProfile;
var handleSaveRedirectUrl = function handleSaveRedirectUrl(draft, action) {
  draft.redirectUrl = action.value;
  return draft;
};
exports.handleSaveRedirectUrl = handleSaveRedirectUrl;
var handleSaveQuery = function handleSaveQuery(draft, action) {
  draft.query = action.value;
  return draft;
};
exports.handleSaveQuery = handleSaveQuery;
var handleSaveLoginProvider = function handleSaveLoginProvider(draft, action) {
  draft.user.loginProvider = action.provider;
  return draft;
};
exports.handleSaveLoginProvider = handleSaveLoginProvider;